import React, { Component, Fragment } from 'react';
import queryString from 'query-string';
import { Link } from 'react-router-dom';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Creators as GroupsActions } from 'store/ducks/groups';

import { Access } from 'common';
import { Page, Panel, Loading, Pagination, Breadcrumbs, Icon } from 'components';

class List extends Component {
  state = {
    breadcrumbs: [
      { name: 'Home', to: '/' },
      { name: 'Configurações', to: '/configs' },
      { name: 'Grupos de Acesso', to: '' },
    ],
  };

  componentDidMount() {
    const { location, getGroupsRequest } = this.props;
    const params = queryString.parse(location.search);
    const page = params.page ? params.page : 1;

    getGroupsRequest(page);
  }

  componentDidUpdate(oldProps) {
    const { location, getGroupsRequest } = this.props;

    if (queryString.parse(oldProps.location.search).page !== queryString.parse(location.search).page) {
      getGroupsRequest(queryString.parse(location.search).page);
    }
  }

  render() {
    const { breadcrumbs } = this.state;
    const { groups } = this.props;

    return (
      <Page>
        <Breadcrumbs breadcrumbs={breadcrumbs} />

        <Page.Title>Grupos de Acesso</Page.Title>

        <Panel className="panel-list">
          {!groups.data.length && groups.loading ? (
            <Loading type="page" size="x-large" />
          ) : (
            <Fragment>
              {groups.loading && <Loading type="table" size="x-large" />}

              <table className="contact-table table table-curved table-striped">
                <thead>
                  <tr>
                    <th>nome</th>
                    <th>alias</th>
                    <th>descrição</th>
                    <th className="text-right">ação</th>
                  </tr>
                </thead>
                <tbody>
                  {!groups.data.length && (
                    <tr>
                      <td colSpan="6" className="text-center">
                        Nenhum registro encontrado.
                      </td>
                    </tr>
                  )}

                  {groups.data.map((group, index) => (
                    <tr key={group.id}>
                      <td>{group.attributes.title}</td>
                      <td>{group.attributes.alias}</td>
                      <td>{group.attributes.description}</td>
                      <td className="text-right">
                        {Access.hasPermissions('edit-access-groups') && (
                          <Link to={`/configs/groups/${group.id}/edit`} className="button-icon">
                            <Icon name="pencil" />
                          </Link>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>

                <tfoot>
                  <tr>
                    <th colSpan="6" />
                  </tr>
                </tfoot>
              </table>

              <Pagination current={groups.page} total={groups.totals} {...this.props} />

              {Access.hasPermissions('edit-access-groups') && (
                <Link className="button-add" to="/configs/groups/create">
                  Adicionar Grupo
                </Link>
              )}
            </Fragment>
          )}
        </Panel>
      </Page>
    );
  }
}

const mapState = state => ({
  groups: state.groups,
});

const mapActions = dispatch => bindActionCreators(GroupsActions, dispatch);

export default connect(
  mapState,
  mapActions,
)(List);
